export const hasPrivilege = (privileges = [], privilageKey) =>
  privileges.includes(privilageKey);
